var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpacePlanet8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_380_36099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_36099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.192383,
    y: 50.0371,
    width: 53.8118,
    height: 53.8118,
    rx: 26.9059,
    transform: "rotate(-67.3553 0.192383 50.0371)",
    fill: "#1273B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.192383,
    y: 50.0371,
    width: 53.8118,
    height: 53.8118,
    rx: 26.9059,
    transform: "rotate(-67.3553 0.192383 50.0371)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_380_36099)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2427,
    cy: 35.8979,
    rx: 29.1929,
    ry: 28.6205,
    transform: "rotate(-67.3553 30.2427 35.8979)",
    fill: "#121E47"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_380_36099)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.3272,
    cy: 36.8114,
    rx: 18.0466,
    ry: 17.617,
    transform: "rotate(-67.3553 21.3272 36.8114)",
    fill: "#B1CDF8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter3_f_380_36099)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64421,
    cy: 4.57398,
    rx: 7.64421,
    ry: 4.57398,
    transform: "matrix(0.203731 -0.979027 0.980524 0.196399 49.1543 45.6826)",
    fill: "#B1CDF8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_380_36099",
    x: 0.192383,
    y: 0.373535,
    width: 70.3818,
    height: 70.3818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_380_36099"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113628 0 0 0 0 0.267573 0 0 0 0 0.354167 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_380_36099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_380_36099",
    x: -43.4707,
    y: -38.2185,
    width: 147.427,
    height: 148.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_380_36099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_380_36099",
    x: -33.8584,
    y: -18.677,
    width: 110.371,
    height: 110.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.75,
    result: "effect1_foregroundBlur_380_36099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_380_36099",
    x: 27.9473,
    y: 9.0586,
    width: 54.498,
    height: 60.0769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.25,
    result: "effect1_foregroundBlur_380_36099"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_36099"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.192383,
    y: 50.0371,
    width: 53.8118,
    height: 53.8118,
    rx: 26.9059,
    transform: "rotate(-67.3553 0.192383 50.0371)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacePlanet8);
export default __webpack_public_path__ + "static/media/spacePlanet8.7acd97a67fea369851ab5a6044002d4d.svg";
export { ForwardRef as ReactComponent };